import React from 'react';
import clsx from 'clsx';
import styles from './index.module.scss';

export interface ImagePreviewMessageProps {
  type?: 'success' | 'error' | 'info';
  center?: boolean;
  progress?: number;
  children?: React.ReactNode;
  className?: string;
}

function ImagePreviewMessage(props: ImagePreviewMessageProps) {
  const style = {
    background: props.progress
      ? `linear-gradient(90deg, #00cc21 ${props.progress}%, white 0%)`
      : undefined,
  };

  return (
    <div
      style={style}
      className={clsx(
        styles.root,
        props.className,
        styles[`type_${props.type}`],
        {
          [styles.center]: props.center,
        }
      )}
    >
      {props.children}
    </div>
  );
}

export default ImagePreviewMessage;
